import {Typography} from '@yandex-delivery/blocks'
import React from 'react'
import type {ContentTextItem} from 'src/api/types'

import {classes} from './TextItem.classes'
import {colorMap, typographyMap} from './TextItem.consts'

type Props = {
  item: ContentTextItem
}
const imageRegex = /\[(.*?)\]\((.*?)\)/

export const TextItem: React.FC<Props> = ({item}) => {
  const parts = item.text.split('\n')

  return (
    <Typography Component="div" color={colorMap[item.color]} variant={typographyMap[item.typography] || 'body2'}>
      <div className={classes.container}>
        {parts.map((part, index) => {
          const match = part.match(imageRegex)
          if (match) {
            return (
              <a href={match[2]} key={index} rel="noreferrer" target="_blank">
                <img alt={match[1]} className={classes.photo} src={match[2]} />
              </a>
            )
          } else {
            return (
              <span className={classes.container} key={index}>
                {part}
              </span>
            )
          }
        })}
      </div>
    </Typography>
  )
}
